// Clerk migration — environment-aware publishable key. Preview keeps using
// the pk_test_ key from frontend/.env; the live production hostnames get a
// hardcoded pk_live_ key instead. Deliberately NOT read from .env — a
// publishable key isn't a secret, but keeping it out of the shared preview
// .env keeps preview traffic from ever accidentally hitting the live Clerk
// instance. Computed once at module load (before ClerkProvider mounts) —
// never swap this after Clerk has initialized.
const PREVIEW_KEY = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY;
const PRODUCTION_KEY = "pk_live_Y2xlcmsuc2NyZWVuaW5nY2lyY2xlLmNvbSQ";

const PRODUCTION_HOSTS = new Set(["screeningcircle.com", "www.screeningcircle.com"]);

const hostname = (typeof window !== "undefined" ? window.location.hostname : "").toLowerCase();

export const CLERK_PUBLISHABLE_KEY = PRODUCTION_HOSTS.has(hostname) ? PRODUCTION_KEY : PREVIEW_KEY;
